import { Box, CircularProgress, Grid } from "@mui/material"
import React, { useContext, useState } from "react"
import { SwitchTab } from "../../../../../components/tabs/SwitchTab"
import { BSVariantListContext } from "../../../../../core/context/beem-shot/BSVariant/BSVariantListContext"
import { ProjectContext } from "../../../../../core/context/project/ProjectContext"
import { BSDashboardVariantCompare } from "./BSDashoardVariantCompare/BSDashboardVariantCompare"
import { CreateVariantDialogContextProvider } from "./BSVariantFormDialog/CreateVariantDialogContext"
import { BSVariantList } from "./BSVariantList/BSVariantList"
import { BSVariantListEmpty } from "./BSVariantList/components/BSVariantListEmpty"
import { BSVariantListNoComparison } from "./BSVariantList/components/BSVariantListNoComparison"

export function BeemShotTab(): React.JSX.Element {
  return (
    <CreateVariantDialogContextProvider>
      <BeemShotTabCore />
    </CreateVariantDialogContextProvider>
  )
}
export function BeemShotTabCore(): React.JSX.Element {
  const { project } = useContext(ProjectContext)
  const { isLoaded, bsVariants } = useContext(BSVariantListContext)

  const [selectedTab, setSelectedTab] = useState<number>(0)

  function handleChangeTabs(event: React.SyntheticEvent, newValue: number): void {
    setSelectedTab(newValue)
  }

  if (!project || !isLoaded) {
    return (
      <Box height="60vh" width="100%" display="flex" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    )
  } else {
    return (
      <Grid container spacing={2}>
        {bsVariants.length > 0 ? (
          <>
            <Grid item xs={12} sx={{ display: "flex" }}>
              <SwitchTab
                selectedTab={selectedTab}
                handleChangeTabs={handleChangeTabs}
                labelLeft="Estimations"
                labelRight="Comparaison des estimations"
              />
            </Grid>
            <Grid item xs={12}>
              {selectedTab === 0 && <BSVariantList bsVariants={bsVariants} />}

              {selectedTab === 1 && (
                <Box>{bsVariants.length > 1 ? <BSDashboardVariantCompare /> : <BSVariantListNoComparison />}</Box>
              )}
            </Grid>
          </>
        ) : (
          <Grid item xs={12} height="100%" display="flex" alignItems="center" justifyContent="center">
            <BSVariantListEmpty />
          </Grid>
        )}
      </Grid>
    )
  }
}
